import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChartBar, ArrowRight } from "@phosphor-icons/react";

export function QuickStatsWidget({ quickStats }) {
  if (!quickStats || quickStats.total_generated < 5) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-[var(--bg-card)] border border-[var(--border)] rounded-lg p-4"
      data-testid="quick-stats-widget"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <ChartBar size={14} className="text-[var(--text-muted)]" />
          <span className="text-xs font-medium text-[var(--text-secondary)]">Last 30 Days</span>
        </div>
        <Link
          to="/insights"
          className="flex items-center gap-1 text-xs text-[var(--text-muted)] hover:text-[#FF4400] transition-colors"
          data-testid="quick-stats-view-insights"
        >
          View full insights <ArrowRight size={12} />
        </Link>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div>
          <p className="text-lg sm:text-xl font-bold text-[var(--text-primary)] font-['JetBrains_Mono']">{quickStats.total_generated}</p>
          <p className="text-[10px] text-[var(--text-muted)]">Pieces Created</p>
        </div>
        <div>
          <p className="text-lg sm:text-xl font-bold text-[var(--text-primary)] font-['JetBrains_Mono']">{(quickStats.total_words_estimated || 0).toLocaleString()}</p>
          <p className="text-[10px] text-[var(--text-muted)]">Est. Words</p>
        </div>
        <div>
          <p className="text-lg sm:text-xl font-bold text-[var(--text-primary)] font-['JetBrains_Mono']">{quickStats.days_active}</p>
          <p className="text-[10px] text-[var(--text-muted)]">Days Active</p>
        </div>
      </div>
    </motion.div>
  );
}
